// RedScreenEffect.js
import { BlendFunction, Effect } from "postprocessing";
import { Uniform, Vector3 } from "three";

// Fragment shader as a string (since we can't import .frag files in this environment)
const fragmentShader = `
uniform float opacity;

void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
    // Mix original color with red
    vec3 redColor = vec3(1.0, 0.0, 0.0);
    vec3 mixedColor = mix(inputColor.rgb, redColor, opacity);
    
    outputColor = vec4(mixedColor, inputColor.a);
}
`;

export class RedScreenEffect extends Effect {
    constructor(opacity = 0.5) {
        super("RedScreenEffect", fragmentShader, {
            blendFunction: BlendFunction.NORMAL,
            uniforms: new Map([
                ["opacity", new Uniform(opacity)]
            ])
        });
    }

    // Helper method to update red intensity
    setOpacity(value) {
        this.uniforms.get("opacity").value = value;
    }
}


//Fragment shader that reads and displays depth
// const fragmentShader = `
// uniform float cameraNear;
// uniform float cameraFar;
// uniform float fogStart;
// uniform float fogEnd;

// float readDepth(sampler2D depthSampler, vec2 coord) {
//     float fragCoordZ = texture2D(depthSampler, coord).x;
//     float viewZ = perspectiveDepthToViewZ(fragCoordZ, cameraNear, cameraFar);
//     return viewZToOrthographicDepth(viewZ, cameraNear, cameraFar);
// }

// void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {

//     float fogEnd = 500.0;
//     float fogStart = 150.0;
//     float fogPower = 0.9;
//     float fogIntensity = 0.75;
//     vec3 fogColor = vec3(2.0, 2.0, 2.0);


//     // Read linearized depth value (0.0 = near plane, 1.0 = far plane)
//     float depth = readDepth(depthBuffer, uv);

//     // Convert normalized depth back to world space distance
//     float worldDistance = mix(cameraNear, cameraFar, depth);

//     // Remap world distance to fog range
//     //float fogFactor = smoothstep(fogStart, fogEnd, worldDistance);

//     // Alternative: use linear interpolation instead of smoothstep
//     float fogFactorLinear = clamp((worldDistance - fogStart) / (fogEnd - fogStart), 0.0, 1.0);

//     // Apply power curve for smooth falloff
//     float fogFactor = pow(fogFactorLinear, fogPower);

//     // Mix original color with fog color based on fog factor
//     // fogFactor = 0.0 -> show original color (no fog)
//     // fogFactor = 1.0 -> show fog color (full fog)
//     vec3 mixedColor = mix(inputColor.rgb, fogColor.a, fogFactor * fogIntensity);

//     outputColor = vec4(mixedColor, 1.0);
// }
// `;